define("shared/components/shared/pre-boarding/social-connect/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "shared/types/social-profile", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _socialProfile, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _trackClickedDone;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"shared/types/social-profile",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @closable={{false}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header>
        <h1 class="o--modalHeader__title u--m__b__xs u--text--lg u--text--center">
          {{t "authorization.connect_social.title_onboarding"}}
        </h1>
        <p class="u--m__b__0 u--text--light u--text--center">
          {{t "authorization.connect_social.sub_title_onboarding"}}
        </p>
      </modal.card-header>
  
      <modal.card-body class="u--p__t__0 u--p__b__lg">
        <div class="tSU--connectWizard" data-test-social-connect="onboarding-modal">
          {{#each this.socialProfileTypesToConnect as |socialProfile|}}
            <Shared::Ui::Button
              @additional="block"
              @class="tSU--connectButton qa--connectSocial_addProfile_Btn {{if socialProfile.isConnected 'is--selected'}}"
              @promise={{unless socialProfile.isConnected (task this.connectProfile socialProfile.code)}}
              @variant="unstyled"
              data-test-social-connect={{concat socialProfile.code "-connect-button"}}
            >
              <div class="cSS--user o--user u--m__0">
                <span
                  class="tSU--connectAvatar o--user__avatar cSS--user__avatar--empty is--selectable is--active cSS--user__avatar--{{socialProfile.code}}"
                  data-test-id="placeholder avatar"
                >
                </span>
              </div>
              <p class="u--text--sm u--text--bold u--m__t__xs u--m__b__0">
                {{socialProfile.name}}
              </p>
              <p class="u--m__tb__0 u--text--xs u--text--light">
                {{t socialProfile.type}}
              </p>
              {{#if socialProfile.isConnected}}
                <p class="u--text--xs u--text--success u--m__b__0">
                  {{svg-jar "verified" class="o--icon o--icon--xs"}}
                  {{t "credentials.status.connected"}}
                </p>
              {{/if}}
            </Shared::Ui::Button>
          {{/each}}
        </div>
        {{#if this.hasConnectedSocialProfiles}}
          <p class="u--m__b__0 u--text--sm u--m__t" data-test-social-connect="social-connect-link">
            {{svg-jar "info" class="o--icon o--icon--sm"}}
            {{t "authorization.connect_social.connect_note"}}
            <Shared::Link
              @href="https://help.later.com/hc/articles/360043244733"
              @openInNewTab={{true}}
              @text={{t "shared_phrases.learn_how"}}
              class="u--text--underline"
            />
          </p>
        {{/if}}
      </modal.card-body>
  
      <modal.card-footer>
        {{#if this.hasConnectedSocialProfiles}}
          <Shared::Ui::Button
            @onClick={{this.handleClose}}
            @variant="primary"
            class="o--btn u--float--right"
            data-test-social-connect="done-button"
          >
            {{t "shared_words.done"}}
          </Shared::Ui::Button>
        {{else}}
          <Shared::Ui::Button
            @onClick={{@closeModal}}
            @variant="mute"
            class="o--btn u--text--light u--float--right qa--social_connect_skip_btn"
            data-test-social-connect="skip-button"
          >
            {{t "shared_phrases.skip_for_now"}}
          </Shared::Ui::Button>
        {{/if}}
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "2ahst09D",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@focusTrap\"],[false,true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h1\"],[14,0,\"o--modalHeader__title u--m__b__xs u--text--lg u--text--center\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.connect_social.title_onboarding\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0 u--text--light u--text--center\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.connect_social.sub_title_onboarding\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 u--p__b__lg\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tSU--connectWizard\"],[14,\"data-test-social-connect\",\"onboarding-modal\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"socialProfileTypesToConnect\"]]],null]],null],null,[[[1,\"          \"],[8,[39,4],[[16,\"data-test-social-connect\",[28,[37,5],[[30,2,[\"code\"]],\"-connect-button\"],null]]],[[\"@additional\",\"@class\",\"@promise\",\"@variant\"],[\"block\",[29,[\"tSU--connectButton qa--connectSocial_addProfile_Btn \",[52,[30,2,[\"isConnected\"]],\"is--selected\"]]],[52,[51,[30,2,[\"isConnected\"]]],[28,[37,8],[[30,0,[\"connectProfile\"]],[30,2,[\"code\"]]],null]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n            \"],[10,0],[14,0,\"cSS--user o--user u--m__0\"],[12],[1,\"\\n              \"],[10,1],[15,0,[29,[\"tSU--connectAvatar o--user__avatar cSS--user__avatar--empty is--selectable is--active cSS--user__avatar--\",[30,2,[\"code\"]]]]],[14,\"data-test-id\",\"placeholder avatar\"],[12],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--sm u--text--bold u--m__t__xs u--m__b__0\"],[12],[1,\"\\n              \"],[1,[30,2,[\"name\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--m__tb__0 u--text--xs u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[[30,2,[\"type\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n\"],[41,[30,2,[\"isConnected\"]],[[[1,\"              \"],[10,2],[14,0,\"u--text--xs u--text--success u--m__b__0\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[\"verified\"],[[\"class\"],[\"o--icon o--icon--xs\"]]]],[1,\"\\n                \"],[1,[28,[35,1],[\"credentials.status.connected\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"]],[]]]]],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasConnectedSocialProfiles\"]],[[[1,\"        \"],[10,2],[14,0,\"u--m__b__0 u--text--sm u--m__t\"],[14,\"data-test-social-connect\",\"social-connect-link\"],[12],[1,\"\\n          \"],[1,[28,[35,9],[\"info\"],[[\"class\"],[\"o--icon o--icon--sm\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"authorization.connect_social.connect_note\"],null]],[1,\"\\n          \"],[8,[39,10],[[24,0,\"u--text--underline\"]],[[\"@href\",\"@openInNewTab\",\"@text\"],[\"https://help.later.com/hc/articles/360043244733\",true,[28,[37,1],[\"shared_phrases.learn_how\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"hasConnectedSocialProfiles\"]],[[[1,\"        \"],[8,[39,4],[[24,0,\"o--btn u--float--right\"],[24,\"data-test-social-connect\",\"done-button\"]],[[\"@onClick\",\"@variant\"],[[30,0,[\"handleClose\"]],\"primary\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,1],[\"shared_words.done\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,4],[[24,0,\"o--btn u--text--light u--float--right qa--social_connect_skip_btn\"],[24,\"data-test-social-connect\",\"skip-button\"]],[[\"@onClick\",\"@variant\"],[[30,3],\"mute\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.skip_for_now\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"socialProfile\",\"@closeModal\"],false,[\"shared/modal\",\"t\",\"each\",\"-track-array\",\"shared/ui/button\",\"concat\",\"if\",\"unless\",\"task\",\"svg-jar\",\"shared/link\"]]",
    "moduleName": "shared/components/shared/pre-boarding/social-connect/index.hbs",
    "isStrictMode": false
  });
  let SocialConnectOnboardingComponent = _exports.default = (_dec = (0, _service.inject)('social/connect-profiles'), (_class = (_trackClickedDone = /*#__PURE__*/new WeakSet(), class SocialConnectOnboardingComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _trackClickedDone);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      _initializerDefineProperty(this, "connectProfiles", _descriptor3, this);
      _defineProperty(this, "connectProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (selectedSocialProfileType) {
          yield this.connectProfiles.addSocialProfile.perform({
            selectedSocialProfileType,
            group: this.currentGroup,
            area: 'social-connect-modal-onboarding'
          });
        }
      }), null, "connectProfile", "drop"));
    }
    get socialProfileProperties() {
      const socialProfileProperties = [{
        name: _socialProfile.SocialPlatformType.Instagram,
        type: 'shared_words.profile',
        code: _socialProfile.SocialProfileCode.Instagram,
        isConnected: false
      }, {
        name: _socialProfile.SocialPlatformType.Facebook,
        type: 'shared_words.page',
        code: _socialProfile.SocialProfileCode.Facebook,
        isConnected: false
      }, {
        name: _socialProfile.SocialPlatformType.Twitter,
        type: 'shared_words.profile',
        code: _socialProfile.SocialProfileCode.Twitter,
        isConnected: false
      }, {
        name: _socialProfile.SocialPlatformType.LinkedIn,
        type: 'shared_phrases.profile_page',
        code: _socialProfile.SocialProfileCode.LinkedIn,
        isConnected: false
      }, {
        name: _socialProfile.SocialPlatformType.TikTok,
        type: 'shared_words.account',
        code: _socialProfile.SocialProfileCode.Tiktok,
        isConnected: false
      }, {
        name: _socialProfile.SocialPlatformType.Pinterest,
        type: 'shared_words.account',
        code: _socialProfile.SocialProfileCode.Pinterest,
        isConnected: false
      }, {
        name: _socialProfile.SocialPlatformType.Youtube,
        type: 'shared_words.channel',
        code: _socialProfile.SocialProfileCode.Youtube,
        isConnected: false
      }];
      if (this.auth.currentAccount?.rolloutThreads) {
        socialProfileProperties.splice(1, 0, {
          name: _socialProfile.SocialPlatformType.Threads,
          type: 'shared_words.account',
          code: _socialProfile.SocialProfileCode.Threads,
          isConnected: false
        });
      }
      return socialProfileProperties;
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get hasConnectedSocialProfiles() {
      return this.currentGroup.socialProfiles.get('length') > 0;
    }
    get connectedSocialProfileTypes() {
      return this.currentGroup.socialProfiles.map(profile => profile.accountType);
    }
    get socialProfileTypesToConnect() {
      return this.socialProfileProperties.map(profile => {
        return {
          ...profile,
          isConnected: this.connectedSocialProfileTypes.includes(profile.name)
        };
      });
    }
    handleClose() {
      _classPrivateMethodGet(this, _trackClickedDone, _trackClickedDone2).call(this);
      this.args.closeModal();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleClose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype)), _class));
  function _trackClickedDone2() {
    this.segment.track('done-connecting-social-profile', {
      area: 'social-connect-modal-onboarding',
      connected_profiles: this.connectedSocialProfileTypes
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialConnectOnboardingComponent);
});